import useAreasByCustomer from '../useAreasByCustomer';
import useCustomerId from '../useCustomerId';

/**
 * Obtains a list of areas by customer
 */
const useSelectedCustomerAreas = (allowRequest = true) => {
  const { customerId } = useCustomerId();
  const props = useAreasByCustomer({ customerId, allowRequest });

  return props;
};

export default useSelectedCustomerAreas;
